import { Search } from 'lucide-react';
import type { ComponentProps } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

/**
 * Campo de busca com a lupa. `aria-label` é obrigatório: busca não tem rótulo visível, e o
 * texto de exemplo some ao digitar — não serve de nome para o leitor de tela.
 */
export function SearchInput({
  className,
  ...props
}: Omit<ComponentProps<typeof Input>, 'type'> & { 'aria-label': string }) {
  return (
    <div className={cn('relative min-w-0 flex-1 sm:max-w-sm', className)}>
      <Search
        aria-hidden
        className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
      />
      <Input type="search" className="pl-8" {...props} />
    </div>
  );
}
